import { ComponentsCategory, ContactsFieldType } from "types/components";
import { images } from "./assets";

const contactsSections = [
  {
    type: ComponentsCategory.CONTACTS_BOX,
    footerInfo: {
      phoneNumberVisible: "+7 (495) 600-84-96",
      phoneNumberLink:"tel:+74956008496",
      emailVisible: "ross@ross-jsc.ru",
      emailLink: "mailto:ross@ross-jsc.ru",
    },
    data: {
      img: images.CompassImage,
      fields: [
        {
          title:
            "Акционерное Общество «Радиоэлектронные и оптические Спецсистемы»",
          value: [
            {
              visibleValue: "",
              linkValue: "",
            },
          ],
          type: ContactsFieldType.TITLE_AND_VALUE,
          offset: 0,
        },
        {
          title: "Телефон:",
          value: [
            {
              visibleValue: "+7(495)600-84-96",
              linkValue: "tel:+74956008496",
            },
            // {
            //   visibleValue: "+7(222)123-45-67",
            //   linkValue: "tel:+72221234567",
            // },
          ],
          type: ContactsFieldType.TITLE_AND_LINK,
          offset: 2,
        },
        {
          title: "Факс: ",
          value: [
            {
              visibleValue: "+7(495)675-60-29",
              linkValue: "",
            },
          ],
          type: ContactsFieldType.TITLE_AND_VALUE,
          offset: 2,
        },
        {
          title: "Электронная почта: ",
          value: [
            {
              visibleValue: "ross@ross-jsc.ru",
              linkValue: "mailto:ross@ross-jsc.ru",
            },
          ],
          type: ContactsFieldType.TITLE_AND_LINK,
          offset: 2,
        },
        // {
        //   title: "Почтовый адрес:    ",
        //   value: [
        //     {
        //       visibleValue: "123456,г.Москва,а/я 1234",
        //       linkValue: "",
        //     },
        //   ],
        //   type: ContactsFieldType.TITLE_AND_VALUE,
        //   offset: 2,
        // },
        {
          title: "Адрес: ",
          value: [
            {
              visibleValue: "Ул. 2-я Машиностроения д. 25,стр. 5",
              linkValue: "Ул. 2-я Машиностроения д. 25, стр. 5",
            },
          ],
          type: ContactsFieldType.TITLE_AND_VALUE,
          offset: 2,
        },
        {
          title:
            "Генеральный директор:",
          value: [
            {
              visibleValue: "Максимов Юрий Алексеевич",
              linkValue: "",
            },
          ],
          type: ContactsFieldType.TITLE_AND_VALUE,
          offset: 2,
        },
        {
          title: "",
          value: [
            {
              visibleValue: "ross@ross-jsc.ru",
              linkValue: "mailto:ross@ross-jsc.ru",
            },
          ],
          type: ContactsFieldType.LINK,
          offset: 0,
        },
        {
          title:
            "Финансовый  Директор:",
          value: [
            {
              visibleValue: "Дробаха Инга Сергеевна",
              linkValue: "",
            },
          ],
          type: ContactsFieldType.TITLE_AND_VALUE,
          offset: 2,
        },
        {
          title: "",
          value: [
            {
              visibleValue: "i.drobaha@ross-jsc.ru",
              linkValue: "mailto:i.drobaha@ross-jsc.ru",
            },
          ],
          type: ContactsFieldType.LINK,
          offset: 0,
        },
        {
          title:
            "Заместитель генерального директора по общим вопросам:",
          value: [
            {
              visibleValue: "Обрезанова Ирина Вадимовна",
              linkValue: "",
            },
          ],
          type: ContactsFieldType.TITLE_AND_VALUE,
          offset: 2,
        },
        {
          title: "",
          value: [
            {
              visibleValue: "i.obrezanova@ross-jsc.ru",
              linkValue: "mailto:i.obrezanova@ross-jsc.ru",
            },
          ],
          type: ContactsFieldType.LINK,
          offset: 0,
        },
        {
          title:
            "Специалист по кадрам:",
          value: [
            {
              visibleValue: "Тарасенко Ирина Анатольевна",
              linkValue: "",
            },
          ],
          type: ContactsFieldType.TITLE_AND_VALUE,
          offset: 2,
        },
        {
          title: "",
          value: [
            {
              visibleValue: "i.tarasenko@ross-jsc.ru",
              linkValue: "mailto:i.tarasenko@ross-jsc.ru",
            },
          ],
          type: ContactsFieldType.LINK,
          offset: 0,
        }
      ],
    },
  },
];

const contactsPageSections = [...contactsSections];

export { contactsPageSections };
